/**
 * @module NAVIGATION
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus. Also handles ARIA attribute toggling
 * for accessibility support
 */
;var NAVIGATION=(function(my){
  var container, button, menu, links, i, len;

  /**
   * @method init
   * @description initializes member variables. registers some listeners
   * @public
   */
  my.init=function() {
    container = document.getElementById( "site-navigation" );
    button = document.getElementById( "menu-toggle" );
    menu = container.getElementsByTagName( "ul" )[0];

    // Hide menu toggle button if menu is empty and return early.
    if ( "undefined" === typeof menu ) {
      button.style.display = "none";
      return;
    }

    //JS is available. Untoggle everything
    container.removeClass("toggled");
    document.body.removeClass("nav-toggled");
    button.removeClass("is-active");
    menu.setAttribute( "aria-expanded", "false" );
    menu.addClass("nav-menu");



    button.onclick = function() {
      if ( container.hasClass("toggled") ) {
        container.removeClass( "toggled" );
        document.body.removeClass("nav-toggled");
        button.removeClass("is-active");
        button.setAttribute( "aria-expanded", "false" );
        menu.setAttribute( "aria-expanded", "false" );
      } else {
        container.addClass("toggled");
        document.body.addClass("nav-toggled");
        button.addClass("is-active");
        button.setAttribute( "aria-expanded", "true" );
        menu.setAttribute( "aria-expanded", "true" );
      }
      container.style.setProperty("--menu-height", menu.offsetHeight+"px");
    };

    // Each time a menu link is focused or blurred, toggle focus.
    menu.qsa("a").forEach(link => {
      link.addEventListener( "focus", NAVIGATION.toggleFocus, true );
      link.addEventListener( "blur", NAVIGATION.toggleFocus, true );
    });
    
    menu.qsa(".menu-item-has-children").forEach(li=>{ //fix for menu rendering glitch in Edge 18
      li.addEventListener("mouseover", function(evt){
        if (this.hasClass('fixed')) return;
        setTimeout(function($this){$this.qsa(".submenu-item").forEach(submenuItem=>submenuItem.style.zoom=1);}, 10, this);
        this.addClass('fixed');
      });
    });
    tabletSubmenuFocusManager();
  };

  /**
   * @method toggleFocus
	 * @description Sets or removes .focus class on an element.
   * @public
	 */
  my.toggleFocus = function() {
    var self = this;

    // Move up through the ancestors of the current link until we hit .nav-menu.
    while ( !self.hasClass("nav-menu") ) {

      // On li elements toggle the class .focus.
      if ( "li" === self.tagName.toLowerCase() ) {
        self.toggleClass("focus");
      }

      self = self.parentElement;
    }
  }

  /**
	 * @method tabletSubmenuFocusManager
   * @description Toggles `focus` class to allow submenu access on tablets.
   * @private
	 */
  var tabletSubmenuFocusManager = function() {
    if ( "ontouchstart" in window ) {
      container.qsa(".menu-item-has-children > a, .page_item_has_children > a")
        .forEach(link=>link.addEventListener( "touchstart", tabletTouchStartFn, false ));
    }
  };

  /**
   * @method tabletTouchStartFn
   * @description eventlistener for tablet based touch events to expand/collapse submenus
   * @private
   */
  var tabletTouchStartFn = function( e ) {
    var menuItem = this.parentNode, i;

    if ( ! menuItem.hasClass( "focus" ) ) {
      e.preventDefault();
      for ( i = 0; i < menuItem.parentNode.children.length; ++i ) {
        if ( menuItem === menuItem.parentNode.children[i] ) {
          continue;
        }
        menuItem.parentNode.children[i].removeClass( "focus" );
      }
      menuItem.addClass( "focus" );
    } else {
      menuItem.removeClass( "focus" );
    }
  };

  return my;
}(NAVIGATION || {}));
